import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconHeight = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.41883 16.5353C9.10528 16.2218 8.59016 16.2218 8.27661 16.5353C7.96306 16.8489 7.96306 17.364 8.27661 17.6775L10.7178 20.1188C11.0314 20.4323 11.5465 20.4323 11.86 20.1188L14.3013 17.6775C14.458 17.5208 14.5252 17.3192 14.5252 17.1176C14.5252 16.9161 14.4356 16.7145 14.3013 16.5577C13.9877 16.2442 13.4726 16.2442 13.159 16.5577L12.084 17.6327V7.6663L13.159 8.74133C13.4726 9.05488 13.9877 9.05488 14.3013 8.74133C14.6148 8.42778 14.6148 7.91266 14.3013 7.59911L11.86 5.15789C11.5465 4.84434 11.0314 4.84434 10.7178 5.15789L8.299 7.59911C8.14223 7.75589 8.07504 7.95746 8.07504 8.15902C8.07504 8.36059 8.14223 8.56216 8.299 8.71894C8.61255 9.03249 9.12767 9.03249 9.44122 8.71894L10.5163 7.6439V17.588L9.41883 16.5353Z" fill="currentColor" />
    <path d="M15.2643 2H7.33595C7.15678 2 7 2.15678 7 2.33595V3.2542C7 3.43338 7.15678 3.59015 7.33595 3.59015H15.2419C15.4211 3.59015 15.5779 3.43338 15.5779 3.2542V2.33595C15.6003 2.15678 15.4435 2 15.2643 2Z" fill="currentColor" />
    <path d="M15.2643 21.6641H7.33595C7.15678 21.6641 7 21.8208 7 22V22.9407C7 23.1198 7.15678 23.2766 7.33595 23.2766H15.2419C15.4211 23.2766 15.5779 23.1198 15.5779 22.9407V22.0224C15.6003 21.8208 15.4435 21.6641 15.2643 21.6641Z" fill="currentColor" />
  </SvgIcon>
);

export default IconHeight;
